module.exports = __webpack_public_path__ + "img/middle_oak_list.0a8bb60f.jpg";